import { API_BASE_URL } from "../config/apiConfig"

export const registerCompany = async (formData, logo) => {
  const formDataToSend = new FormData()

  // Append all text fields
  formDataToSend.append("companyName", formData.companyName)
  formDataToSend.append("registrationNumber", formData.registrationNumber)
  formDataToSend.append("loginEmail", formData.loginEmail)
  formDataToSend.append("password", formData.password)
  formDataToSend.append("dateEstablished", formData.dateEstablished)
  formDataToSend.append("address", formData.address)
  formDataToSend.append("city", formData.city)
  formDataToSend.append("country", formData.country)
  formDataToSend.append("postalCode", formData.postalCode)
  formDataToSend.append("mainPhoneNumber", formData.mainPhoneNumber)
  formDataToSend.append("emailAddress", formData.emailAddress)
  formDataToSend.append("website", formData.website)
  formDataToSend.append("defaultCurrency", formData.defaultCurrency)
  formDataToSend.append("operatingPorts", JSON.stringify(formData.operatingPorts))
  formDataToSend.append("workingHours", formData.workingHours)
  formDataToSend.append("whoWeAre", formData.whoWeAre)
  formDataToSend.append("vision", formData.vision)
  formDataToSend.append("mission", formData.mission)
  formDataToSend.append("purpose", formData.purpose)
  formDataToSend.append("facebookUrl", formData.facebookUrl)
  formDataToSend.append("instagramUrl", formData.instagramUrl)
  formDataToSend.append("whatsappNumber", formData.whatsappNumber)
  formDataToSend.append("linkedinProfile", formData.linkedinProfile)
  formDataToSend.append("skypeId", formData.skypeId)

  // Append logo file if selected
  if (logo) {
    formDataToSend.append("logo", logo)
  }

  const response = await fetch(`${API_BASE_URL}/companies/register`, {
    method: "POST",
    body: formDataToSend,
  })

  return response.json()
}

export const getPublicCompanyAbout = async (companyName) => {
  const response = await fetch(`${API_BASE_URL}/companies/public/about/${companyName}`)

  if (!response.ok) {
    throw new Error("Failed to fetch company public info")
  }

  return response.json()
}

export const getCompanyBySlug = async (companyName) => {
  // The endpoint returns { exists: true/false, data: {...} }
  try {
    const response = await fetch(`${API_BASE_URL}/companies/public/about/${companyName}`)
    if (!response.ok) {
      return { exists: false }
    }
    return response.json()
  } catch (error) {
    return { exists: false }
  }
}

export const getPublicCompanyContact = async (companyName) => {
  const response = await fetch(`${API_BASE_URL}/companies/public/contact/${companyName}`)

  if (!response.ok) {
    throw new Error("Failed to fetch company contact info")
  }

  return response.json()
}

export const getCompanyProfile = async (token) => {
  const response = await fetch(`${API_BASE_URL}/companies/me`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error("Failed to fetch company profile")
  }

  return response.json()
}

export const getUserProfile = async (token) => {
  const response = await fetch(`${API_BASE_URL}/users/me`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error("Failed to fetch user profile")
  }

  return response.json()
}
